module.exports = "<div class=\"form-control component-buildin-control\"> <div class=dropdown style=float:left></div> </div>";


//////////////////
// WEBPACK FOOTER
// ./app/components/form/buildIn-control/buildIn-control.wx.html
// module id = 1958
// module chunks = 50